import { CatalogPartRevisionView } from "src/api/generated/erp/db/types/tables/catalogPartRevisionView.ts";
import { ConfigurationProductFamilyVersion } from "src/api/generated/erp/db/types/tables/configurationProductFamilyVersion.ts";

export type CatalogPartRevisionImportCompatibility =
	"compatible" | "productFamilyVersionUpgraded" | "sourceProductFamilyVersionNewer" | "differentProductFamily";

type ProductFamilyVersion = Pick<
	ConfigurationProductFamilyVersion,
	"configurationProductFamilyVersionId" | "versionNumber"
>;

export interface GetCatalogPartRevisionImportCompatibilityParams {
	sourceRevision: Pick<CatalogPartRevisionView, "configurationProductFamilyVersionId"> | null | undefined;
	targetProductFamilyVersion: ProductFamilyVersion | null | undefined;
	/** All versions of the target part's product family. */
	productFamilyVersionOptions: ProductFamilyVersion[];
	importConfiguratorSelections: boolean;
}

/**
 * Version numbers are comparable only within one family, so a source version that is not among the target family's
 * versions belongs to another family. A newer source version of the same family is never importable; the other
 * outcomes matter only when configurator selections are imported.
 */
export function getCatalogPartRevisionImportCompatibility({
	sourceRevision,
	targetProductFamilyVersion,
	productFamilyVersionOptions,
	importConfiguratorSelections,
}: GetCatalogPartRevisionImportCompatibilityParams): CatalogPartRevisionImportCompatibility {
	const sourceVersionId = sourceRevision?.configurationProductFamilyVersionId;
	if (targetProductFamilyVersion == null || sourceVersionId == null) return "compatible";

	const sourceVersion = productFamilyVersionOptions.find(
		(version) => version.configurationProductFamilyVersionId === sourceVersionId,
	);
	if (sourceVersion != null && sourceVersion.versionNumber > targetProductFamilyVersion.versionNumber)
		return "sourceProductFamilyVersionNewer";
	if (!importConfiguratorSelections) return "compatible";
	if (sourceVersion == null) return "differentProductFamily";
	if (sourceVersion.versionNumber < targetProductFamilyVersion.versionNumber) return "productFamilyVersionUpgraded";
	return "compatible";
}
